import { render, staticRenderFns } from "./DateSelect.vue?vue&type=template&id=be73bcf2"
import script from "./DateSelect.vue?vue&type=script&lang=ts"
export * from "./DateSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports